import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useApprovedPartners } from '@/lib/api/partnerships';
import { useUiStore } from '@/lib/store/ui';
import { ChevronDown, Settings2 } from 'lucide-react';
import { useState } from 'react';

const ORGS = [
  { key: 'all', label: 'All Organisations', color: '#6b7280' },
  { key: 'dev', label: 'DEV Bench Test', color: '#22a050' },
  { key: 'am', label: 'AM Flights Ops', color: '#2563eb' },
];

export function OrgSelector() {
  const active = useUiStore((s) => s.activeOrg);
  const setOrg = useUiStore((s) => s.setOrg);
  const openTenantSettings = useUiStore((s) => s.setTenantSettingsOpen);
  const activeEntry = ORGS.find((o) => o.key === active) ?? ORGS[0]!;
  const [open, setOpen] = useState(false);
  // Only fetch partnerships while the dropdown is open — avoids a failing
  // cross-origin request on every app load when the controller is unreachable.
  const { data: partners } = useApprovedPartners({ enabled: open });

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5">
          <span className="size-2 rounded-full" style={{ background: activeEntry.color }} />
          <span className="hidden sm:inline">{activeEntry.label}</span>
          <ChevronDown size={10} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel>Organisation Scope</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {ORGS.map((o) => (
          <DropdownMenuItem key={o.key} onClick={() => setOrg(o.key)}>
            <span className="size-2 rounded-full mr-1" style={{ background: o.color }} />
            {o.label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <div className="flex items-center justify-between px-2 pt-1">
          <DropdownMenuLabel className="p-0">Active Partnerships</DropdownMenuLabel>
          <button
            type="button"
            onClick={() => openTenantSettings(true)}
            className="text-(--color-text3) hover:text-(--color-green)"
            aria-label="Tenant settings"
          >
            <Settings2 size={13} />
          </button>
        </div>
        {partners && partners.length > 0 ? (
          partners.map((p) => (
            <div
              key={p.partner_tenant}
              className="px-2 py-1 text-[0.769em] flex items-center gap-1.5 text-(--color-text2)"
            >
              <span className="size-2 rounded-full bg-(--color-text3)" />
              {p.partner_tenant}
            </div>
          ))
        ) : (
          <div className="px-2 py-1 text-[0.692em] text-(--color-text3) italic">
            No active partnerships.
          </div>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
